import { useTranslation } from 'react-i18next';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useBilling } from '../context/BillingContext';

export const TrialBanner = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { billing } = useBilling();

  if (!billing || billing.subscribed || !billing.trial_active) return null;

  const link = billing.payment_link
    ? `${billing.payment_link}?prefilled_email=${encodeURIComponent(user?.email || '')}`
    : null;

  return (
    <div
      className="bg-teal-500/10 border-b border-teal-500/25 px-4 py-1.5 flex items-center justify-center gap-3 flex-wrap"
      data-testid="trial-banner"
    >
      <p className="text-[11px] text-teal-300 flex items-center gap-1.5">
        <Sparkles size={12} className="shrink-0" />
        {t('billing.trial_banner', { days: billing.trial_days_left })}
      </p>
      {link && (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[11px] font-semibold text-teal-200 hover:text-white inline-flex items-center gap-1 underline underline-offset-2 transition-colors duration-150"
          data-testid="trial-banner-subscribe-link"
        >
          {t('billing.subscribe')}
          <ArrowRight size={11} />
        </a>
      )}
    </div>
  );
};

export default TrialBanner;
